import React from 'react'
import Cart from '../components/core/Cart/index'

export default function CartPage() {
  return (
    <div>
        <Cart></Cart>
    </div>
  )
}
